import { IRiderInfo } from '../interfaces/IRiderInfo';

export type RiderExclusivityRule = {
  sourceRider: string;
  targetRider: string;
  inverse: boolean;
};

/**
 * Applies rider exclusivity rules to an initial riders list (e.g. on init).
 * When source rider is eligible, target rider is set to inverse of source.
 */
export function applyRiderExclusivityRules(
  riders: IRiderInfo[],
  rules: RiderExclusivityRule[],
): IRiderInfo[] {
  if (rules.length === 0) return riders;
  const byName = new Map(riders.map(r => [r.rider, r]));
  for (const rule of rules) {
    const source = byName.get(rule.sourceRider);
    const target = byName.get(rule.targetRider);
    if (source && target) {
      const targetEligible = rule.inverse
        ? !source.isEligible
        : source.isEligible;
      byName.set(rule.targetRider, { ...target, isEligible: targetEligible });
    }
  }
  return riders.map(r => byName.get(r.rider) ?? r);
}
